import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import MetaList from './MetaList/MetaList';
import MetaListItem from './MetaList/MetaListItem';
import DateFormat from './DateFormat';

export default class AnimalInfo extends React.Component {
    static propTypes = {
        modifierClass: PropTypes.array,
        name: PropTypes.string,
        species: PropTypes.string,
        breed: PropTypes.string,
        sex: PropTypes.string,
        dateOfBirth: PropTypes.string,
        insuranceNumber: PropTypes.number,
        customerSupportUrl: PropTypes.string
    }

    static defaultProps = {
        firstName: '',
        species: '',
        breed: '',
        sex: '',
        dateOfBirth: '',
        insuranceNumber: 0,
        modifierClass: [],
        customerSupportUrl: '#'
    };

    render() {
        return (
            <MetaList
                actionShow={false}
                actionLabel={'Ändra'}
                actionOnClick={() => {  }}
                push={true}
            >
                <MetaListItem
                    title={this.props.firstName}
                    contents={[
                        this.props.species + (this.props.breed ? ' - ' : '') + this.props.breed
                    ]}
                />
                <MetaListItem
                    title={"Kön: "}
                    compactMode
                    contents={[
                        this.props.sex
                    ]}
                />
                <dd></dd>
                <MetaListItem
                    title={"Födelsedatum: "}
                    compactMode
                    contents={[
                        <DateFormat date={this.props.dateOfBirth} />
                    ]}
                />
            </MetaList>
        );
    }
};
